/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Screenshot Icon component.
 */
export const ScreenShotIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);

  return (
    <svg width={iconSize} height={iconSize} viewBox={`0 0 ${iconSize} ${iconSize}`} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.6087 1H1.5C1.22386 1 1 1.22386 1 1.5V3.72727' stroke={iconColor} strokeWidth={1.5} strokeLinecap='round' />
      <path d='M10.3913 13L12.5 13C12.7761 13 13 12.7761 13 12.5L13 10.2727' stroke={iconColor} strokeWidth={1.5} strokeLinecap='round' />
      <path d='M13 3.72727L13 1.5C13 1.22386 12.7761 1 12.5 1L10.3913 1' stroke={iconColor} strokeWidth={1.5} strokeLinecap='round' />
      <path d='M1 10.2727L1 12.5C1 12.7761 1.22386 13 1.5 13L3.6087 13' stroke={iconColor} strokeWidth={1.5} strokeLinecap='round' />
      <rect x='3.80371' y='4' width='6.45652' height='6' stroke={iconColor}/>
    </svg>
  );
};

export default ScreenShotIcon;
